"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPrintArgs = exports.printArgs = exports.getPrintArgsSerializer = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
function getPrintArgsSerializer() {
    return (0, serializers_1.dataEnum)([
        [
            'V1',
            (0, serializers_1.struct)([['edition', (0, serializers_1.u64)()]]),
        ],
        [
            'V2',
            (0, serializers_1.struct)([['edition', (0, serializers_1.u64)()]]),
        ],
    ], { description: 'PrintArgs' });
}
exports.getPrintArgsSerializer = getPrintArgsSerializer;
function printArgs(kind, data) {
    return Array.isArray(data)
        ? { __kind: kind, fields: data }
        : { __kind: kind, ...(data ?? {}) };
}
exports.printArgs = printArgs;
function isPrintArgs(kind, value) {
    return value.__kind === kind;
}
exports.isPrintArgs = isPrintArgs;
//# sourceMappingURL=printArgs.js.map